module.exports = __webpack_public_path__ + "static/media/logowhite.97ad9841.svg";